import { render, staticRenderFns } from "./BannerSlot.vue?vue&type=template&id=77ae7447&scoped=true&"
import script from "./BannerSlot.vue?vue&type=script&lang=js&"
export * from "./BannerSlot.vue?vue&type=script&lang=js&"
import style0 from "./BannerSlot.vue?vue&type=style&index=0&id=77ae7447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae7447",
  null
  
)

export default component.exports